export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'ad-blocking-complete-guide',
    title: '91浏览器广告拦截功能完全指南：告别烦人广告',
    excerpt: '详细解析91网页浏览器内置广告拦截功能的工作原理、自定义规则设置技巧，以及如何在不同网站场景下灵活运用广告拦截，让您的浏览体验更加清爽高效。',
    content: `<p>在日常网页浏览中，弹窗广告、横幅广告和视频前贴片广告严重影响了用户体验。91网页浏览器内置了强大的广告拦截引擎，能够智能识别并屏蔽各类广告内容。</p>
<h2>广告拦截的工作原理</h2>
<p>91网页浏览器的广告拦截功能基于智能规则引擎，结合社区维护的过滤规则库和机器学习算法，能够精准识别广告元素。系统会实时分析网页的DOM结构和网络请求，对匹配广告特征的资源进行拦截。</p>
<h2>自定义拦截规则</h2>
<p>用户可以根据个人需求添加自定义过滤规则。在浏览器设置中进入"隐私与安全 → 广告拦截"，即可看到自定义规则管理界面。支持通配符匹配和正则表达式，高级用户还可以导入第三方规则列表。</p>
<h2>白名单管理</h2>
<p>对于您信任的网站，可以将其加入白名单，允许正常的广告展示。这不仅支持创作者，也能避免部分网站因广告拦截而限制访问。91浏览器支持按域名、子域名和具体页面路径设置白名单。</p>
<h2>性能影响</h2>
<p>经过优化后的广告拦截引擎对浏览器性能影响极小。实测数据显示，开启广告拦截后页面加载速度平均提升40%，内存占用仅增加不到5%，同时还能节省大量数据流量。</p>`,
    category: 'browser-tips',
    author: '李明',
    date: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20browser%20interface%20with%20clean%20ad-free%20webpage%20display%2C%20soft%20warm%20gradient%20background%20in%20light%20neutral%20tones%2C%20clean%20UI%20design%20with%20shield%20icon%20subtlely%20visible%2C%20professional%20software%20product%20photography%20style%2C%20bright%20and%20airy%2C%20editorial%20quality&width=1200&height=630&seq=article-adblock&orientation=landscape',
    tags: ['广告拦截', '使用技巧', '隐私保护'],
  },
  {
    slug: 'privacy-mode-explained',
    title: '隐私模式深度解析：91浏览器如何保护你的上网隐私',
    excerpt: '全面了解91网页浏览器隐私模式的技术实现细节，包括无痕浏览、cookie隔离、指纹防护等多层隐私保护机制，让您在上网时无后顾之忧。',
    content: `<p>隐私保护已成为现代浏览器最受关注的功能之一。91网页浏览器从架构层面设计了完善的隐私保护体系，下面我们将深入解析其核心技术。</p>
<h2>无痕浏览模式</h2>
<p>91浏览器的无痕模式不仅仅是不保存浏览历史那么简单。在无痕模式下，所有浏览数据——包括cookie、缓存文件、表单数据和网站权限——都会在关闭窗口后自动清除。更重要的是，无痕模式下的网络请求会使用独立的临时存储空间，与正常模式的存储完全隔离。</p>
<h2>防指纹追踪技术</h2>
<p>浏览器指纹是网站识别用户的一种隐蔽手段，通过收集浏览器版本、屏幕分辨率、安装字体、插件列表等信息生成唯一标识。91浏览器通过在关键参数中加入微量随机噪声，使指纹变得不稳定而无法用于长期追踪，同时不影响正常网页渲染。</p>
<h2>第三方Cookie隔离</h2>
<p>默认情况下，91浏览器会阻止所有第三方Cookie，防止广告网络跨站点追踪用户行为。系统还会定期清理已知追踪器的本地存储数据，确保用户隐私不被泄露。</p>`,
    category: 'security-guide',
    author: '王芳',
    date: '2026-07-25',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20privacy%20concept%20with%20subtle%20shield%20and%20lock%20visuals%2C%20clean%20abstract%20background%20in%20warm%20neutral%20tones%2C%20soft%20lighting%2C%20professional%20tech%20aesthetic%2C%20bright%20and%20modern%20composition&width=1200&height=630&seq=article-privacy&orientation=landscape',
    tags: ['隐私保护', '安全上网', '浏览器功能'],
  },
  {
    slug: 'speed-optimization-tips',
    title: '5个技巧让你的91浏览器快到飞起',
    excerpt: '分享五个实用的浏览器性能优化技巧，包括缓存管理、扩展精简、硬件加速配置等，帮助你释放91网页浏览器的全部性能潜力，享受秒开的极速体验。',
    content: `<p>浏览器速度是影响上网体验的关键因素。即使是最优秀的浏览器，也可以通过一些优化技巧进一步提速。以下五个技巧将帮助您的91网页浏览器发挥最佳性能。</p>
<h2>1. 定期清理缓存数据</h2>
<p>浏览器缓存虽然能加速页面加载，但积累过多的缓存反而会拖慢性能。建议每月清理一次缓存（保留Cookie和密码），在设置 → 隐私与安全 → 清除浏览数据中操作。</p>
<h2>2. 管理浏览器扩展</h2>
<p>每个扩展都会消耗系统资源。定期检查已安装的扩展，禁用或删除不常用的那些。91浏览器内置了扩展性能监控面板，可以直观看到每个扩展的内存和CPU占用情况。</p>
<h2>3. 开启硬件加速</h2>
<p>在设置中确保"使用硬件加速"选项已开启。这会让浏览器利用显卡GPU来渲染网页，大幅提升图形密集型页面的加载和滚动性能。</p>
<h2>4. 优化标签页管理</h2>
<p>同时打开过多标签页会消耗大量内存。91浏览器的标签页休眠功能会自动冻结长时间未访问的标签页，释放内存资源。在设置中可以自定义休眠触发时间。</p>
<h2>5. 更新到最新版本</h2>
<p>91浏览器团队持续优化渲染引擎性能。确保您使用的是最新版本，每次更新通常都会带来5%-15%的性能提升。</p>`,
    category: 'browser-tips',
    author: '张伟',
    date: '2026-07-20',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20speed%20and%20performance%20concept%20with%20flowing%20light%20trails%2C%20minimalist%20design%20with%20warm%20neutral%20tones%2C%20soft%20gradient%20background%2C%20modern%20tech%20aesthetic%2C%20dynamic%20yet%20clean%20composition&width=1200&height=630&seq=article-speed&orientation=landscape',
    tags: ['性能优化', '使用技巧', '浏览器加速'],
  },
  {
    slug: 'phishing-protection',
    title: '钓鱼网站如何识别？91浏览器安全防护详解',
    excerpt: '钓鱼攻击是当前最常见的网络安全威胁之一。本文详解91网页浏览器内置的智能反钓鱼系统如何实时识别和拦截钓鱼网站，保护您的账号和财产安全。',
    content: `<p>网络钓鱼攻击每年造成数十亿美元的经济损失。91网页浏览器通过多层安全机制，为用户构建了全方位的反钓鱼防护体系。</p>
<h2>实时威胁检测引擎</h2>
<p>91浏览器内置的智能安全引擎会实时分析您访问的每个网页。通过比对全球威胁情报数据库、分析页面结构和内容特征、检测可疑的JavaScript行为，系统能在毫秒级判断网站安全性。</p>
<h2>URL安全验证</h2>
<p>当您访问的网址与知名网站高度相似时（如使用形近字符、多余子域名等手法），浏览器会自动弹出警告页面。系统还支持HTTPS强制升级，确保数据传输加密。</p>
<h2>下载安全扫描</h2>
<p>在您下载文件时，91浏览器会自动对文件进行安全扫描，检测已知恶意软件特征。对于可疑文件，系统会建议用户谨慎操作，并阻止高危文件的自动执行。</p>`,
    category: 'security-guide',
    author: '赵强',
    date: '2026-07-18',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20concept%20with%20subtle%20warning%20symbols%20and%20shield%20elements%2C%20minimalist%20design%20in%20warm%20neutral%20tones%2C%20clean%20abstract%20background%2C%20professional%20tech%20aesthetic%2C%20soft%20lighting&width=1200&height=630&seq=article-phishing&orientation=landscape',
    tags: ['安全防护', '钓鱼攻击', '网络安全'],
  },
  {
    slug: 'version-4-2-release',
    title: '91浏览器v4.2正式发布：更快的渲染引擎，更智能的标签管理',
    excerpt: '91网页浏览器最新版本v4.2正式上线，带来全新渲染引擎、智能标签分组、跨设备同步等多项重大更新，全面提升您的浏览体验。',
    content: `<p>经过三个月的开发与测试，91网页浏览器v4.2版本正式发布。本次更新聚焦性能提升和用户体验优化，带来了多项令人期待的新功能。</p>
<h2>全新渲染引擎</h2>
<p>v4.2版本搭载了自研的Velo渲染引擎2.0，页面渲染速度相比上一代提升35%，JavaScript执行效率提升28%。在标准的Web基准测试中，综合得分达到行业领先水平。</p>
<h2>智能标签分组</h2>
<p>全新的标签分组功能能够根据网站类别自动将标签归类，支持自定义分组名称和颜色标记。配合标签休眠机制，即使同时打开50个以上的标签页，浏览器依然流畅运行。</p>
<h2>跨设备无缝同步</h2>
<p>通过91账号登录，书签、密码、历史记录和打开的标签页可以在电脑版和手机版之间实时同步。端到端加密确保同步数据的安全性。</p>`,
    category: 'product-updates',
    author: '产品团队',
    date: '2026-07-15',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20release%20announcement%20visual%20with%20clean%20geometric%20patterns%2C%20warm%20neutral%20gradient%20background%2C%20minimalist%20design%2C%20professional%20tech%20branding%20style%2C%20bright%20and%20contemporary&width=1200&height=630&seq=article-release&orientation=landscape',
    tags: ['版本更新', '新功能', '产品动态'],
  },
  {
    slug: 'web-standards-2026',
    title: '2026年Web技术趋势：浏览器扮演的关键角色',
    excerpt: '从WebAssembly到WebGPU，从PWA到WebXR，2026年的Web技术正以前所未有的速度发展。91网页浏览器积极拥抱新标准，为用户带来更丰富的网络体验。',
    content: `<p>2026年，Web技术生态持续蓬勃发展。作为连接用户与互联网的重要工具，浏览器在推动Web技术创新中扮演着核心角色。</p>
<h2>WebAssembly 3.0</h2>
<p>WebAssembly 3.0规范的落地使得接近原生性能的复杂应用在浏览器中运行成为现实。91浏览器率先完整支持该规范，视频编辑、3D建模、科学计算等重型应用都能在浏览器中流畅运行。</p>
<h2>WebGPU全面普及</h2>
<p>WebGPU API让网页应用可以充分利用现代GPU的计算能力。游戏、数据可视化和机器学习推理等场景在91浏览器中的性能表现显著提升。</p>
<h2>Privacy Sandbox</h2>
<p>随着第三方Cookie的逐步淘汰，Privacy Sandbox等隐私保护广告技术成为行业趋势。91浏览器在保护用户隐私的同时，也支持合规的广告投放技术。</p>`,
    category: 'internet-trends',
    author: '刘洋',
    date: '2026-07-10',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20technology%20concept%20with%20flowing%20data%20visualizations%2C%20minimalist%20design%20in%20warm%20neutral%20tones%2C%20modern%20tech%20aesthetic%2C%20soft%20gradient%20background%2C%20clean%20composition&width=1200&height=630&seq=article-webtech&orientation=landscape',
    tags: ['Web技术', '行业趋势', '前端开发'],
  },
];